<template>
  <div class="tw:flex tw:flex-col tw:gap-4 tw:p-4">
    <div>
      <QToggle
        v-model="excludeExternalItems"
        data-testid="exclude-external-items"
        dense
      >
        <div class="tw:flex tw:items-center tw:gap-1">
          {{ getLocaleText("stream_filters_other.exclude_external_items") }}

          <QIcon name="info">
            <StreemTooltip
              anchor="top middle"
              self="bottom middle"
            >
              {{
                getLocaleText(
                  "stream_filters_other.exclude_external_items_tooltip"
                )
              }}
            </StreemTooltip>
          </QIcon>
        </div>
      </QToggle>
    </div>
    <div v-if="externalItemsEnabled">
      <QToggle
        v-model="onlyShowExternalItems"
        data-testid="show-external-items"
        dense
      >
        <div class="tw:flex tw:items-center tw:gap-1">
          {{ getLocaleText("stream_filters_other.only_external_items") }}

          <QIcon name="info">
            <StreemTooltip
              anchor="top middle"
              self="bottom middle"
            >
              {{
                getLocaleText(
                  "stream_filters_other.only_external_items_tooltip"
                )
              }}
            </StreemTooltip>
          </QIcon>
        </div>
      </QToggle>
    </div>
  </div>
</template>

<script setup lang="ts">
import { QToggle } from "quasar";
import { computed } from "vue";

import { getLocaleText } from "shared/boot/i18n";
import StreemTooltip from "shared/components/base/StreemTooltip.vue";

const externalItemsEnabled = defineModel<boolean>("externalItemsEnabled");
const onlyShowExternalItems = defineModel<boolean>("onlyShowExternalItems");

const excludeExternalItems = computed({
  get() {
    return !externalItemsEnabled.value;
  },
  set(value) {
    externalItemsEnabled.value = !value;
  },
});
</script>
